var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendOuline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send 1",
    clipPath: "url(#clip0_2221_612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.928 7.39461L2.40519 1.36851C1.79337 1.11461 1.1022 1.22631 0.601363 1.65985C0.100527 2.09347 -0.108934 2.76154 0.0547531 3.40343L1.48189 9.00002L0.0547531 14.5966C-0.108934 15.2385 0.100491 15.9066 0.601327 16.3402C1.10311 16.7746 1.79446 16.8849 2.40519 16.6315L16.928 10.6054C17.5892 10.3311 18 9.71591 18 9.00002C18 8.28413 17.5892 7.66897 16.928 7.39461ZM16.5238 9.63125L2.00097 15.6573C1.75674 15.7586 1.49162 15.7159 1.29169 15.5428C1.09179 15.3697 1.01146 15.1134 1.07678 14.8572L2.43589 9.52736H7.67645C7.96772 9.52736 8.20383 9.29125 8.20383 8.99999C8.20383 8.70872 7.96772 8.47261 7.67645 8.47261H2.43592L1.07678 3.14285C1.01146 2.88663 1.09179 2.63034 1.29169 2.45727C1.49159 2.28419 1.75663 2.24137 2.00093 2.34269L16.5238 8.36879C16.9149 8.53107 16.9453 8.89297 16.9453 9.00002C16.9453 9.10707 16.9149 9.46897 16.5238 9.63125Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2221_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOuline);
export default __webpack_public_path__ + "static/media/sendOuline.e0c06eb665baef9e2642193f576ac770.svg";
export { ForwardRef as ReactComponent };